import { render, staticRenderFns } from "./CustomersTable.vue?vue&type=template&id=9ae0450e"
import script from "./CustomersTable.vue?vue&type=script&lang=js"
export * from "./CustomersTable.vue?vue&type=script&lang=js"
import style0 from "./CustomersTable.vue?vue&type=style&index=0&id=9ae0450e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports